(function (ws) {
    'use strict';

    ws.views.customerOnboardingCountryRequestModel = ws.views.modal.extend({
        events: _.extend({}, ws.views.modal.prototype.events, {
            'click .changeCountryCls': 'submit',
            'click .nochangeCountryCls': 'cancel'
        }),

        /**
         * Initialize
         */
        initialize: function() {
            ws.views.modal.prototype.initialize.call(this);
            this.eventAgg.on('countryRequest', this.countryRequest.bind(this));
            this.from = '';
        },

        countryRequest: function(from, countryType) {
            this.from = from;
            this.countryType = countryType;
            this.eventAgg.trigger('countryRequestModalId');
        },

        submit: function(e) {
            this.eventAgg.trigger('saveAndContinueFunction', e, this.from, this.countryType);
        },

        cancel: function(e) {
            this.eventAgg.trigger('searchSelectedLanguage', this.from, this.countryType);
        }
    });
}(westcon));
